import {Component, Input, OnInit} from '@angular/core';
import { OptionService } from "../option/option.service";

@Component({
    selector: 'thankyou-order-headline',
    templateUrl: './thankyou-order.headline.component.html',
})
export class ThankyouOrderHeadlineComponent implements OnInit {

    /**
     * the current step
     */
    @Input() step: string;

    /**
     * Type of the project
     */
    @Input() projectType: string;

    /**
     * textkey for the headline on the thank you page
     */
    textkeyHeadline: string;

    /**
     * Special thank you message that should be visible
     */
    eventThankYou: any = false;

    /**
     * Constructor
     * @param optionService
     */
    constructor(private optionService: OptionService) {}

    /**
     * called when initializing the component
     */
    ngOnInit() {
        // on event projects we get the thank you message from the creater
        if(this.projectType === "event") {
            this.eventThankYou = this.optionService.getEventOption('text_thankyou');
        }

        // depending on the project type, we use a different headline
        if(this.projectType === "giftshop") {
            this.textkeyHeadline = "giftshop.thankyou.headline.default";
        }
        else {
            this.textkeyHeadline = "thankyou.headline.default";
        }
    }
}
